// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from "react";

const MY_TASKS = [
  { id:1, title:"Implement real-time notifications", status:"in-progress", priority:"P0", project:"Platform", due:"2026-02-10", tags:["development"] },
  { id:2, title:"Database performance optimization", status:"backlog", priority:"P1", project:"Platform", due:"2026-02-22", tags:["development"] },
  { id:3, title:"Fleet management API integration", status:"backlog", priority:"P1", project:"Fleet", due:"2026-02-25", tags:["development"] },
  { id:4, title:"Code review: billing module", status:"in-progress", priority:"P1", project:"Billing", due:"2026-02-09", tags:["development"] },
  { id:5, title:"Update CI/CD pipeline", status:"todo", priority:"P2", project:"DevOps", due:"2026-02-14", tags:["development","operations"] },
  { id:6, title:"Security audit remediation", status:"todo", priority:"P0", project:"Security", due:"2026-02-08", tags:["development","urgent"] },
  { id:7, title:"Mobile app crash fix", status:"in-progress", priority:"P0", project:"Mobile", due:"2026-02-07", tags:["development","urgent"] },
  { id:8, title:"API rate limiting implementation", status:"done", priority:"P1", project:"Platform", due:"2026-02-05", tags:["development"] },
  { id:9, title:"Write E2E tests for auth flow", status:"todo", priority:"P2", project:"Testing", due:"2026-02-16", tags:["development"] },
  { id:10, title:"Documentation: API endpoints v3", status:"todo", priority:"P3", project:"Docs", due:"2026-02-20", tags:["development"] },
  { id:11, title:"Refactor notification service", status:"backlog", priority:"P2", project:"Platform", due:"2026-02-28", tags:["development"] },
  { id:12, title:"Performance monitoring setup", status:"done", priority:"P1", project:"DevOps", due:"2026-02-04", tags:["development","operations"] },
];

export default function MyTasksPage() {
  const [tasks, setTasks] = useState(MY_TASKS);
  const [view, setView] = useState("grouped");
  const [statusFilter, setStatusFilter] = useState("");

  const today = new Date().toISOString().split("T")[0];
  const overdue = tasks.filter(t => t.due < today && t.status !== "done");
  const dueToday = tasks.filter(t => t.due === today && t.status !== "done");
  const thisWeek = tasks.filter(t => { const d=new Date(t.due); const w=new Date(); w.setDate(w.getDate()+7); return d>new Date(today) && d<=w && t.status!=="done"; });
  const upcoming = tasks.filter(t => { const d=new Date(t.due); const w=new Date(); w.setDate(w.getDate()+7); return d>w && t.status!=="done"; });
  const done = tasks.filter(t => t.status === "done");

  const toggleStatus = (id) => {
    setTasks(prev => prev.map(t => t.id===id ? {...t, status: t.status==="done"?"todo":"done"} : t));
  };

  const renderTask = (t) => (
    <div key={t.id} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:"1px solid #334155"}}>
      <input type="checkbox" checked={t.status==="done"} onChange={()=>toggleStatus(t.id)} style={{accentColor:"#10b981"}} />
      <div style={{flex:1}}>
        <div style={{fontSize:13,fontWeight:600,color:t.status==="done"?"#64748b":"#e2e8f0",textDecoration:t.status==="done"?"line-through":"none"}}>{t.title}</div>
        <div style={{fontSize:11,color:"#64748b",display:"flex",gap:8,marginTop:2}}>
          <span>{t.project}</span><span>{t.due}</span>
          {t.tags.map(tag=><span key={tag} className="tag-pill">{tag}</span>)}
        </div>
      </div>
      <span className={"priority-tag priority-"+t.priority.toLowerCase()}>{t.priority}</span>
      <span className={"status-badge status-"+(t.status==="done"?"completed":t.status==="in-progress"?"in-progress":"pending")} style={{fontSize:10}}>{t.status}</span>
    </div>
  );

  return (
    <div>
      <div className="page-header">
        <div><h1>My Tasks</h1><p>{tasks.filter(t=>t.status!=="done").length} open tasks</p></div>
        <div style={{display:"flex",gap:8}}>
          <button className={"btn "+(view==="grouped"?"btn-primary":"btn-secondary")} onClick={()=>setView("grouped")}>Grouped</button>
          <button className={"btn "+(view==="list"?"btn-primary":"btn-secondary")} onClick={()=>setView("list")}>List</button>
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Overdue</div><div className="stat-value" style={{color:"#ef4444"}}>{overdue.length}</div></div>
        <div className="stat-card"><div className="stat-label">Due Today</div><div className="stat-value" style={{color:"#eab308"}}>{dueToday.length}</div></div>
        <div className="stat-card"><div className="stat-label">This Week</div><div className="stat-value">{thisWeek.length}</div></div>
        <div className="stat-card"><div className="stat-label">Completed</div><div className="stat-value" style={{color:"#10b981"}}>{done.length}</div></div>
      </div>

      {view === "grouped" ? (
        <div>
          {overdue.length > 0 && <div className="card"><div className="card-header"><h3 style={{color:"#ef4444"}}>Overdue</h3><span className="card-badge" style={{background:"#ef4444"}}>{overdue.length}</span></div>{overdue.map(renderTask)}</div>}
          {dueToday.length > 0 && <div className="card"><div className="card-header"><h3 style={{color:"#eab308"}}>Due Today</h3><span className="card-badge" style={{background:"#eab308",color:"#1e293b"}}>{dueToday.length}</span></div>{dueToday.map(renderTask)}</div>}
          {thisWeek.length > 0 && <div className="card"><div className="card-header"><h3>This Week</h3><span className="card-badge">{thisWeek.length}</span></div>{thisWeek.map(renderTask)}</div>}
          {upcoming.length > 0 && <div className="card"><div className="card-header"><h3>Upcoming</h3><span className="card-badge">{upcoming.length}</span></div>{upcoming.map(renderTask)}</div>}
          {done.length > 0 && <div className="card"><div className="card-header"><h3 style={{color:"#10b981"}}>Completed</h3><span className="card-badge" style={{background:"#10b981"}}>{done.length}</span></div>{done.map(renderTask)}</div>}
        </div>
      ) : (
        <div className="card">{tasks.map(renderTask)}</div>
      )}

      <div className="card" style={{marginTop:16}}>
        <div className="card-header"><h3>Productivity This Week</h3></div>
        <div className="chart-bar-container">
          {["Mon","Tue","Wed","Thu","Fri"].map((d,i) => (
            <div key={d} className="chart-bar-row">
              <span className="chart-bar-label">{d}</span>
              <div className="chart-bar-track"><div className="chart-bar-fill" style={{width:[40,65,80,55,70][i]+"%"}}>{[2,4,5,3,4][i]} tasks</div></div>
            </div>
          ))}
        </div>
      </div>

      <div className="grid-2" style={{marginTop:16}}>
        <div className="card">
          <div className="card-header"><h3>By Project</h3></div>
          {[...new Set(tasks.map(t=>t.project))].map(proj => (
            <div key={proj} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:"1px solid #334155"}}>
              <span style={{fontSize:13,color:"#e2e8f0"}}>{proj}</span>
              <span style={{fontSize:13,fontWeight:600,color:"#10b981"}}>{tasks.filter(t=>t.project===proj).length}</span>
            </div>
          ))}
        </div>
        <div className="card">
          <div className="card-header"><h3>By Priority</h3></div>
          {["P0","P1","P2","P3"].map(pri => {
            const c=tasks.filter(t=>t.priority===pri).length;
            const colors={P0:"#ef4444",P1:"#f97316",P2:"#eab308",P3:"#64748b"};
            return (
              <div key={pri} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"1px solid #334155"}}>
                <span className={"priority-tag priority-"+pri.toLowerCase()}>{pri}</span>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <div style={{width:80,height:6,background:"#334155",borderRadius:3}}><div style={{width:(c/tasks.length*100)+"%",height:6,background:colors[pri],borderRadius:3}}/></div>
                  <span style={{fontSize:13,fontWeight:600,color:colors[pri]}}>{c}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}